import styled from '@emotion/styled';

import { BoxProps } from '.';

export const Container = styled.div<BoxProps>`
  display: ${(props) => (props.flex ? 'flex' : 'block')};
  flex-direction: ${(props) => props.flexDirection || 'row'};
  align-items: ${(props) => props.alignItems || 'flex-start'};
  justify-content: ${(props) => props.justifyContent || 'flex-start'};
`;
